import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e474843")

_pushScopeId("data-v-1e474843")
const _hoisted_1 = { class: "container agencies-container" }
const _hoisted_2 = { class: "default-page-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "footer-space" }, null, -1)
const _hoisted_4 = { class: "product-edit-container" }
const _hoisted_5 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_6 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_7 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_8 = {
  type: "submit",
  class: "order-modify-button-wrapper btn-green",
  form: "agencyDetailsForm"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-save fs-20" }, null, -1)
const _hoisted_10 = { class: "my-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "arrow up" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AgencyDetailsComponent = _resolveComponent("AgencyDetailsComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.agency.name) + " ", 1),
    _createVNode(_component_AgencyDetailsComponent, {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
      modelValue: _ctx.agency,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.agency = $event)),
      "edit-mode": true,
      ref: "details"
    }, null, 8, ["modelValue"]),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("button", {
            type: "button",
            class: "order-modify-button-wrapper dark-circle-button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
          }, _toDisplayString(_ctx.$t('button.cancel')), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("button", _hoisted_8, [
            _hoisted_9,
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('button.save')), 1)
          ])
        ])
      ]),
      _createVNode("button", {
        class: "arrow-button",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
        type: "button"
      }, [
        _hoisted_11
      ])
    ])
  ]))
})